type RenderIfProps = {
  condition: boolean;
  children: React.ReactNode;
  fallback?: React.ReactNode;
};

/**
 * Renders children if the condition is true; otherwise, renders the fallback.
 */
export const RenderIf: React.FC<RenderIfProps> = ({ condition, children, fallback = null }) => {
  return <>{condition ? children : fallback}</>;
};
